import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterDifficultySubcategories.module.scss";
import {useFilterDifficultySubcategoriesLogic} from "./FilterDifficultySubcategories.logic";
import {FilterDifficultySubcategory} from "../filter-difficulty-subcategory/FilterDifficultySubcategory";

export interface IFilterDifficultySubcategoriesProps {
  difficultyCategoryId: number;
}

export const FilterDifficultySubcategories: VoidFunctionComponent<IFilterDifficultySubcategoriesProps> = ({difficultyCategoryId}) => {
  const {difficultyIds} = useFilterDifficultySubcategoriesLogic(difficultyCategoryId);
  return (
    <ol className={s.container}>
      {difficultyIds.map((difficultyId) =>  <FilterDifficultySubcategory difficultyId={difficultyId} key={`filter-difficulty-category-${difficultyCategoryId}-difficulty-${difficultyId}`} />)}
    </ol>
  );
}

